<div class="scheduler__no-auth text-center pt-4">
    <p class="mb-2 scheduler__title-no-auth">Scheduler</p>
    <p><i class="scheduler__fa-no-auth fas fa-ban"></i></p>
    <p>Missing authorization token or missing fleetId.<br>User is not associated with the fleet.</p>
</div>